/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMicrophoneSlash: {
  name: 'microphone-slash';
  data: string;
} = {
  name: 'microphone-slash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.228 4.667A4.001 4.001 0 0 1 16 6v5a1 1 0 1 1-2 0V6a2 2 0 0 0-3.886-.667 1 1 0 0 1-1.886-.666Zm4.607 11.264A5 5 0 0 1 7 11a1 1 0 1 0-2-.001 7.001 7.001 0 0 0 6 6.93V20H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-2.071c.055-.008.11-.016.165-.026a1 1 0 0 0-.33-1.972ZM18 10a1 1 0 0 1 1 1 6.99 6.99 0 0 1-.399 2.333 1 1 0 1 1-1.885-.666A4.99 4.99 0 0 0 17 11a1 1 0 0 1 1-1ZM4.707 3.293a1 1 0 0 0-1.414 1.414l16 16a1 1 0 0 0 1.414-1.414l-16-16Z" fill="currentColor"/></svg>`,
};
